import { Box, Typography, Stack } from '@mui/material';
import { CK, FONT_BODY } from '../portalStyles';

// AWS-console-style section block for the finding detail panel: a small grey
// uppercase heading followed by its content. Mirrors the grouped layout AWS
// Security Hub / GuardDuty use in the finding side-panel.
export function DetailSection({ title, children }) {
  return (
    <Box
      sx={{
        py: 1.5,
        // A hairline between blocks reads as the Admin console's stacked
        // sections; the last block drops it so the panel doesn't end on a rule.
        borderBottom: `1px solid ${CK.border}`,
        '&:last-of-type': { borderBottom: 'none' },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          mb: 1,
          color: CK.muted,
          fontFamily: FONT_BODY,
          letterSpacing: '0.08em',
          fontWeight: 700,
        }}
      >
        {title}
      </Typography>
      {children}
    </Box>
  );
}

// A label/value row inside a section (AWS shows finding attributes as a stacked
// key/value list). Renders nothing when the value is empty.
export function DetailField({ label, value }) {
  if (value === null || value === undefined || value === '') return null;
  return (
    <Stack
      direction="row"
      useFlexGap
      flexWrap="wrap"
      sx={{ gap: 2, py: 0.4, alignItems: 'baseline' }}
    >
      <Typography
        sx={{
          minWidth: 130,
          flexShrink: 0,
          fontFamily: FONT_BODY,
          fontSize: '0.875rem',
          color: CK.muted,
        }}
      >
        {label}
      </Typography>
      <Typography
        component="div"
        sx={{
          flex: '1 1 180px',
          minWidth: 0,
          fontFamily: FONT_BODY,
          fontSize: '0.875rem',
          wordBreak: 'break-word',
          color: CK.navy,
        }}
      >
        {value}
      </Typography>
    </Stack>
  );
}
